import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropdown-menu",
  "use": "dropdown-menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dropdown-menu\"><path fill-rule=\"evenodd\" d=\"m16 9.5 3-3h-6l3 3Zm-11-6h14.01c1.1 0 1.99.9 1.99 2v5c0 1.101-.9 2-2 2H4.99c-1.1 0-1.99-.899-1.99-2v-5c0-1.1.9-2 2-2ZM3 18.498h18c0 1.101-.9 2-2 2H4.99c-1.1 0-1.99-.899-1.99-2ZM3 14.5h18c0 1.1-.9 2-2 2H4.99c-1.1 0-1.99-.9-1.99-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol